export const forBusiness_email_matters = [
	{
		icon: '💪',
		subtitle: 'matterData_subtitle1',
	},
	{
		icon: '🖼️',
		subtitle: 'matterData_subtitle2',
	},
	{
		icon: '🎉',
		subtitle: 'matterData_subtitle3',
	},
	{
		icon: '⏳',
		subtitle: 'matterData_subtitle4',
	},
	{
		icon: '🚀',
		subtitle: 'matterData_subtitle5',
	},
];

export const matters_email_AboveList = [
	{
		text: 'matterData_textAbove_text1',
	},
];
